import React from 'react';

import AdditionalInformationActivity from './AdditionalInformationActivity';
import CandidateActivity from './CandidateActivity';
import CandidateAnswersActivity from './CandidateAnswersActivity';
import ConsultationActivity from './ConsultationActivity';
import ConsultationRequestedActivity from './ConsultationRequestedActivity';
import ExpertRequestActivity from './ExpertRequestActivity';
import NetworkAddActivity from './NetworkAddActivity';
import UserActivity from './UserActivity';

const config = {
  user_joined_platform: {
    icon: 'user-plus',
    renderer: (rProps: any) => <UserActivity event="joined OnFrontiers" {...rProps} />,
  },
  user_inetexpert_add: {
    icon: 'chart-network',
    renderer: NetworkAddActivity,
  },
  user_consultation_requested: {
    icon: 'phone',
    renderer: ConsultationRequestedActivity,
  },
  user_consultation_confirmed: {
    icon: 'phone',
    renderer: (rProps: any) => <ConsultationActivity state="confirmed" {...rProps} />,
  },
  user_consultation_closed: {
    icon: 'phone',
    renderer: (rProps: any) => (
      <ConsultationActivity state={rProps.activity.context.raw.closing_state} {...rProps} />
    ),
  },
  user_candidate_add: {
    icon: 'clipboard-list',
    renderer: CandidateActivity,
  },
  user_candidate_update: {
    icon: 'clipboard-list',
    renderer: CandidateActivity,
  },
  user_candidate_answers_set: {
    icon: 'clipboard-list',
    renderer: CandidateAnswersActivity,
  },
  profile_additional_information_updated: {
    icon: 'pen',
    renderer: AdditionalInformationActivity,
  },
  expert_request_created: {
    icon: 'clipboard-list',
    renderer: ExpertRequestActivity,
  },
  expert_request_closed: {
    icon: 'lock',
    renderer: ExpertRequestActivity,
  },
  expert_request_open: {
    icon: 'unlock',
    renderer: ExpertRequestActivity,
  },
};

export default function activityConfig(activity: any): any {
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return config[`${activity.object_type}_${activity.action}`];
}
